const AUTH_DEBUG_KEY = 'ml_auth_debug';
const PREFIX = '[auth-debug]';

const isDebugEnabled = () => {
  if (import.meta.env.DEV) return true;
  if (typeof localStorage === 'undefined') return false;
  return localStorage.getItem(AUTH_DEBUG_KEY) === '1';
};

const sanitizeMeta = (meta = {}) => {
  const safeMeta = { ...meta };
  if ('token' in safeMeta) {
    safeMeta.token = safeMeta.token ? '[present]' : '[missing]';
  }
  if ('authorization' in safeMeta) {
    safeMeta.authorization = safeMeta.authorization ? '[present]' : '[missing]';
  }
  return safeMeta;
};

export const logAuthDebug = (event, meta = {}) => {
  if (!isDebugEnabled()) return;
  console.info(`${PREFIX} ${event}`, sanitizeMeta(meta));
};

export const warnAuthDebug = (event, meta = {}) => {
  if (!isDebugEnabled()) return;
  console.warn(`${PREFIX} ${event}`, sanitizeMeta(meta));
};
